<template>
    <div class="conf-wrp">
        <div class="content-wrp">
            <div class="content">
                <el-form class="form" :model="value" :rules="rules" ref="form" label-width="20%">
                    <section>
                        <div class="title">
                            <span>基础设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="标题设置:" prop="titleSet">
                                <el-checkbox v-model="value.titleSet">商品标题超过平台限制自动截断（最多60个字符）</el-checkbox>
                            </el-form-item>
                             <el-form-item label="淘宝商家编码设置:" prop="isAutoFillOuterId">
                                <el-checkbox v-model="value.isAutoFillOuterId" :true-label="1" :false-label="0">基础资料款式编码自动填充淘宝商家编码</el-checkbox>
                                <span style="color: red; font-size: 12px">&nbsp;（注意：开启配置，新增淘宝资料时，基础资料款式编码自动填充淘宝商家编码，若淘宝资料已完善，则不会自动填充。）</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>库存设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="铺货时，进行库存默认设置:" >
                                <el-switch v-model="checkInstock"></el-switch>
                            </el-form-item>
                            <el-form-item v-if="checkInstock" label="库存默认值:" prop="instock">
                                <div class="instock">
                                    <span class="prev">铺货到淘宝到SKU库存默认值&nbsp;=&nbsp;</span>
                                    <el-input v-model="value.instock" style="width: 120px" placeholder="请输入库存数"></el-input>
                                    <span class="tips">&nbsp;(此值应用于商品铺货时，对商品各SKU的库存初始化值，最大值为99999)</span>
                                </div>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>图片设置</span>
                        </div>
                        <div class="conf">
                            <div style="padding-left:15%;">图片修正规则：按照平台比例和尺寸大小要求，修正成最优且符合要求的图片。若图片大小不符合平台要求，将自动压缩后重新上传，不支持压缩20M以上的图片。</div>
                            <el-form-item prop="autoCropImageConfigList">
                                <el-checkbox-group v-model="value.autoCropImageConfigList">
                                    <el-checkbox label="mainImg">1:1主图</el-checkbox>
                                    <el-checkbox label="mainImg34">3:4主图</el-checkbox>
                                    <el-checkbox label="wirelessDesc">手机端详情图</el-checkbox>
                                </el-checkbox-group>
                                <el-checkbox-group></el-checkbox-group>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>运费模板设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="运费设置:" prop="shipSet" label-width="120px">
                                <div class="ship-wrp" v-if="shopList.length > 0">
                                    <div class="item" v-for="(item, idx) in shopList" :key="idx">
                                        <div class="shopname">
                                            <img class="shop-img" :src="item.icon"/>
                                            <el-tooltip v-if="item.channelIcon" :content="item.channelName" style="margin: 0px -6px 0px 6px;">
                                                <el-image :src="item.channelIcon" style="width: 18px; height: 18px;overflow: unset;top: 4px;"></el-image>
                                            </el-tooltip>
                                            <span>{{ item.shortTitle || item.title }}</span>
                                        </div>
                                        <el-select 
                                            :loading="selectLoading" 
                                            v-model="shipsValue[item.id]" 
                                            placeholder="请选择运费模板" 
                                            clearable
                                            @visible-change="changeSelect(item.id, item.userId)"
                                            width="150px">
                                            <el-option
                                                v-for="ship in shipsTemplate[item.id]"
                                                :key="ship.id"
                                                :label="ship.name"
                                                style="width: 150px;"
                                                :title="ship.name"
                                                :value="ship.id">
                                            </el-option>
                                        </el-select>
                                        <div><el-link class="no-border" @click="refreshTemplate(item.id, item.userId)">刷新模板</el-link></div>
                                    </div>
                                </div>
                                <span v-else class="no-shops">暂无平台店铺</span>
                            </el-form-item>
                        </div>
                    </section>
                    <section>
                        <div class="title">
                            <span>上架设置</span>
                        </div>
                        <div class="conf">
                            <el-form-item label="上架设置:" prop="shelfType">
                                <el-radio-group v-model="value.shelfType">
                                    <el-radio :label="1">立即上架</el-radio>
                                    <!-- <el-radio :label="3">定时上架</el-radio> -->
                                    <el-radio :label="2">放入草稿箱</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>
                    </section>
                    <PriceConf ref="PriceConfRef" platform="tb" :priceList="value.price" :shopPriceConf="value.shopPriceConf"></PriceConf>
                    <div class="btns">
                        <el-button type="primary" @click="save">保存模板</el-button>
                        <el-button @click="back">返回</el-button>
                    </div>
                </el-form>
            </div>
        </div>
    </div>
</template>
<script>
import '@/assets/css/prod.scss';
import {getDistributionConfig, updateDistributionConfig, getTBTemplateList} from '@servers/prod/conf/index.js'
import { refreshTaobaoFreightTemplte } from '@api/prod/conf/index.js';
import PriceConf from './components/PriceConf.vue';

const PLATFORMID = 'tb';

export default {
    props: {
        back: Function
    },
    components: {
        PriceConf
    },
    data() {
        const validateInstock = (rule, value, callback) => {
            const reg = /^[0-9]*$/;
            if (value === '') {
                callback(new Error('请输入库存数'));
            } else if (!reg.test(value)) {
                callback(new Error('库存数必须是数字, 且为整数'))
            } else if (value <= 0 || value >= 99999) {
                callback(new Error('库存数必须为0-99999之间的整数'))
            } else {
                callback();
            }
        }
        return {
            checkInstock: false,
            shopList: [],
            value: {
                titleSet: true,
                isAutoFillOuterId: false,
                instock: null,
                shelfType: 2,
                autoCropImageConfigList:[],
            },
            selectLoading: false,
            rules: {
                instock: [
                    {required: true, message: '请输入库存数'},
                    {validator: validateInstock}
                ],
                shelfType: [
                    {required: true, message: ''},
                ]
            },
            shipsValue: {// 运费模板
            },
            shipsTemplate: { // 运费模板列表

            }
        }
    },
    mounted() {
        this.getConf();
    },
    methods: {
        async getConf() {
            const res = await getDistributionConfig({shopType: PLATFORMID});
            this.shopList = this.$store.getters.get_AllShops_BySource('tb');
            if (res) {
                this.checkInstock = res.isCommodityStock === 1;
                this.value.titleSet = res.isCommodityTitle === 1;
                this.value.isAutoFillOuterId = res.isAutoFillOuterId || 0;
                this.value.instock = res.stockNumber;
                this.value.shelfType = res.shelfState || this.value.shelfType;
                this.value.price = res.price ? JSON.parse(res.price) : [];
                this.value.autoCropImageConfigList = res.autoCropImageConfigList ? res.autoCropImageConfigList : [];
                this.value.shopPriceConf = res.shopPriceConf ? JSON.parse(res.shopPriceConf) : [];
            }
            this.intiTemplate(res && res.templateList);
        },
        async getTemplateList(userId) {
            const list = await getTBTemplateList({userId: userId});
            if (list) {
                return list.map(ship => {
                    return {
                        name: ship.name,
                        id: ship.templateId + ''
                    }
                });
            }
            return [];
        },
        async refreshTemplate(shopId, userId) {
            this.selectLoading = true;
            // const list = await this.getTemplateList(userId);
            refreshTaobaoFreightTemplte([shopId]).then((res) => {
                this.selectLoading = false;
                if (res.result === 1) {
                    this.$message.success('刷新模板成功');
                }
            }).catch(() => {
                this.selectLoading = false;
            });
            // this.shipsTemplate[shopId] = list;
            // const idx = list.findIndex(item => item.id === this.shipsValue[shopId]);
            // if (idx === -1) {
            //     this.shipsValue[shopId] = '';
            // }
            
        },
        intiTemplate(templateList=[]) {
            const ships = {};
            const shipsTemp = {};

            this.shopList.forEach(shop => {
                const template = templateList.find(item => item.shopId == shop.id && item.templateId);
                ships[shop.id] = template?.templateId || '';
                shipsTemp[shop.id] = template ? [{ name: template.templateName, id: template.templateId }] : [];
            })
            this.shipsTemplate = shipsTemp;
            this.shipsValue = ships;
        },
        async changeSelect(shopId, userId) {
            if (!this.shipsTemplate[shopId]?.length ||
                (this.shipsTemplate[shopId].length && this.shipsTemplate[shopId][0].id == this.shipsValue[shopId])) {
                this.selectLoading = true;
                const list = await this.getTemplateList(userId)
                const idx = list.findIndex(item => item.id == this.shipsValue[shopId]);
                if (idx === -1) {
                    this.shipsValue[shopId] = '';
                }
                this.shipsTemplate[shopId] = list;
                this.selectLoading = false;
            }
        },
        findTemplateName(shopid, tempId) {
            if (!this.shipsTemplate[shopid]) return '';
            for(let item of this.shipsTemplate[shopid]) {
                if (item.id == tempId) {
                    return item.name;
                }
            }
        },
        save() {
            this.$refs.form.validate(async valid => {
                if (valid) {
                    const {
                        titleSet,
                        isAutoFillOuterId,
                        imgNumSet,
                        instock,
                        autoCropImageConfigList,
                        shelfType,
                    } = this.value;
                    const templateList = []
                    Object.keys(this.shipsValue).forEach(id => {
                        const name = this.findTemplateName(id, this.shipsValue[id]);
                        const channel = this.shopList.find(shop => shop.id == id)?.channel
                        // if (this.shipsValue[id] && name) {
                            templateList.push({
                                shopId: id,
                                templateId: this.shipsValue[id] || null,
                                templateName: name || null,
                                channel
                            });
                        // }
                    });
                     let [commConf,shopConf] = this.$refs.PriceConfRef.getData();
                    const res = await updateDistributionConfig({
                        shopType: PLATFORMID,
                        isCommodityTitle: titleSet ? 1 : 0,
                        isAutoFillOuterId: isAutoFillOuterId || 0,
                        isCommodityImage: imgNumSet ? 1 : 0,
                        isCommodityStock: this.checkInstock ? 1 : 0,
                        stockNumber: this.checkInstock ? `${instock === null ? '' : instock}` : '',
                        shelfState: shelfType,
                        templateList: templateList,
                        autoCropImageConfigList,
                        price: JSON.stringify(commConf),
                        shopPriceConf:JSON.stringify(shopConf),
                    });
                    if (res) {
                        this.$message.success('保存成功');
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss">

</style>